import React from 'react';
import { BrowserRouter as Router, Route, Link} from "react-router-dom";
import './App.css';
import Accueil from "./Component/Accueil";
import ListeHarmoniesStyliste from "./Component/ListeHarmoniesStyliste";
import AffichageHarmonie from "./Component/AffichageHarmonie";
import ChoixPiece from "./Component/ChoixPiece";
import ChoixStylisteVisualiseur from "./Component/ChoixStylisteVisualiseur";
import Info from "./Component/Info";
import Visualiseur from "./Component/Visualiseur";
import VisualiseurV33 from "./Component/Visualiseur-V33";
import AffichageProduitsSelectionnes from "./Component/AffichageProduitsSelectionnes";
function App() {
  return (
      <Router basename="/Visualiseur_new">


        <Route exact path="/" component={Accueil} />
        <Route path="/pieces/:piece/visualiseur/pieces" component={Accueil}  />
        <Route exact path="/pieces/:piece/styliste" component={ListeHarmoniesStyliste}  />
        <Route exact path="/pieces/:piece/styliste/:page/" component={ListeHarmoniesStyliste}  />
        <Route exact path="/pieces/:piece" component={ChoixStylisteVisualiseur}  />
        <Route exact path="/pieces/:piece/styliste/harmonie/:id" component={AffichageHarmonie} />
        <Route exact path="/pieces" component={ChoixPiece} />
        <Route exact path="/infos" component={Info} />
        <Route exact path="/pieces/:piece/visualiseur" component={Visualiseur} />
          <Route exact path="/v33/pieces/:piece/visualiseur" component={VisualiseurV33} />
        <Route exact path="/pieces/:piece/visualiseur/produits" component={AffichageProduitsSelectionnes} />
      </Router>
  );
}


export default App;
